import {Component, Input} from '@angular/core';
import {endOfDay, isAfter, isBefore, isSameDay, parse, set, startOfDay} from 'date-fns';
import {TaskDto} from '../../../../../Models/Tasks/General/task.interface';
import {YuColorDto} from 'yukit';

@Component({
  selector: 'app-task-item',
  templateUrl: './task-item.component.html',
  styleUrls: ['./task-item.component.scss'],
  standalone: false
})
export class TaskItemComponent {

  @Input() task!: TaskDto;

  /**
   * Obtener el color del estado de la tarea
   *
   */
  get colorStatus(): YuColorDto {

    if (this.task.completado > 99.99 || this.task.cerrado) {
      return 'success';
    }

    if (this.checkInProcessTask()) {
      return 'info';
    }

    return 'medium'
  }


  /**
   * Obtener el estado de la tarea
   *
   */
  get status(): string {

    if (this.task.completado > 99.99 || this.task.cerrado) {
      return 'Completado';
    }

    if (this.checkInProcessTask()) {
      return 'En curso';
    }

    return 'Pendiente'
  }


  /**
   * Comprobar que la tarea está en curso
   *
   */
  private checkInProcessTask(): boolean {
    const now = new Date();
    const itemDate = parse(this.task.dia, 'yyyy-MM-dd', now);

    let itemStartDate = startOfDay(itemDate);
    let itemEndDate = endOfDay(itemDate);

    if (this.task.hora) {
      const [hours, minutes] = this.task.hora.split(':').map(Number);
      itemStartDate = set(itemDate, {hours, minutes});
    }

    if (this.task.hora_fin) {
      const [hours, minutes] = this.task.hora_fin.split(':').map(Number);
      itemEndDate = set(itemDate, {hours, minutes});
    }

    return isSameDay(itemDate, now) && isBefore(itemStartDate, now) && isAfter(itemEndDate, now);
  }

}
